const MAX_FILE_SIZE = 530000;

const ACCEPTED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.svg'];

export default {
    MAX_FILE_SIZE,
    ACCEPTED_EXTENSIONS,
};
